import { DateTime } from 'luxon';

/**
 * Sorts an array of billable items by their timestamp.
 *
 * @typeParam T - The type of billable item, must have a `timeKey` property containing an ISO date string
 * @param billableEvents - The array of billable items to sort
 * @param order - The sort order, either 'asc' for ascending or 'desc' for descending (defaults to 'asc')
 * @returns A new sorted array of billable items
 */
export const sortBillableItems = <T extends { timeKey: string }>(
  billableEvents: Array<T>,
  order: 'asc' | 'desc' = 'asc',
): Array<T> => {
  const sortedBillableEvents = [...billableEvents].sort((a, b) => {
    const aTimestamp = DateTime.fromISO(a.timeKey).toMillis();
    const bTimestamp = DateTime.fromISO(b.timeKey).toMillis();

    if (order === 'asc') return aTimestamp - bTimestamp;
    return bTimestamp - aTimestamp;
  });

  return sortedBillableEvents;
};
